import React, { useState, useContext } from 'react';
import styles from '../css/Login.module.css';
import { Link, useNavigate } from 'react-router-dom';
import { UserContext } from '../contexts/UserContext';
import axiosInstance from '../config/axiosConfig';

export default function Login() {
  const [fuser, setFuser] = useState('');
  const [fpassword, setFpassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const { setUser } = useContext(UserContext);
  const navigate = useNavigate();

  const handleLogin = async () => {
    setError('');
    setSuccess('');
    setLoading(true);
    
    try {
      const response = await axiosInstance.post('/login', {
        username: fuser,
        password: fpassword
      });

      setUser({
        id: response.data.user.id,
        email: response.data.user.email
      });

      setSuccess(response.data.message || 'Login exitoso');
      setTimeout(() => navigate('/home'), 500);

    } catch (err) {
      if (err.response?.data?.error) {
        setError(err.response.data.error);
      } else if (err.request) {
        setError('No se pudo conectar con el servidor');
      } else {
        setError('Error en la solicitud');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.contentWrapper}>
      <div className={styles.tablesContainer}>
        <table className={styles.infoTable}>
          <tbody>
            <tr>
              <td className={styles.tableHeader}>
                <div className={styles.headerContent}>
                  <span>Conectar</span>
                </div>
              </td>
            </tr>
            <tr>
              <td className={styles.tableBody}>
                <div className={styles.inputGroup}>
                  <label htmlFor="fuser">Nombre de usuario:</label>
                  <input
                    type="text"
                    id="fuser"
                    name="fuser"
                    value={fuser}
                    onChange={(e) => setFuser(e.target.value)}
                    disabled={loading}
                  />
                </div>
                <div className={styles.inputGroup}>
                  <label htmlFor="fpassword">Contraseña:</label>
                  <input
                    type="password"
                    id="fpassword"
                    name="fpassword"
                    value={fpassword}
                    onChange={(e) => setFpassword(e.target.value)}
                    disabled={loading}
                  />
                </div>
                <div className={styles.checkboxGroup}>
                  <input type="checkbox" id="fremember" name="fremember" value="Remember" disabled={loading} />
                  <label htmlFor="fremember">Recordarme</label>
                </div>

                <button className={styles.btnSubmit} onClick={handleLogin} disabled={loading}>
                  {loading ? 'Conectando...' : 'Aceptar'}
                </button>

                {error && <p style={{ color: 'red', marginTop: '10px' }}>{error}</p>}
                {success && <p style={{ color: 'green', marginTop: '10px' }}>{success}</p>}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className={styles.forgotLink}>
        <Link to="/">Olvidó su Contraseña</Link>
      </div>
    </div>
  );
}